module.exports = __webpack_public_path__ + "static/media/checked-small.7bbc7525.svg";